var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var SessionResourceController = {
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resources" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {SessionResourceDownloadDto[]}
    ******************************************************************************************************/
    GetResources: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resources", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resources/search" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} query
        * @param {string} queryLng
        * @returns {SessionResourceDownloadDto[]}
    ******************************************************************************************************/
    SearchResources: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("query", JSON.stringify(data.query));
        fd.append("queryLng", JSON.stringify(data.queryLng));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resources/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/resources/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {SessionResourceDownloadDto}
    ******************************************************************************************************/
    GetResource: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/resources/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/resources" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SessionResourceUploadDto} dto
        * @returns {SessionResourceDownloadDto}
    ******************************************************************************************************/
    CreateResource: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/resources", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/resources/{id}" and http method "PUT" to call the back-end.
    
        * @param {string} id
        * @param {SessionResourceUploadDto} dto
        * @returns {SessionResourceDownloadDto}
    ******************************************************************************************************/
    UpdateResource: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/resources/{id}", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/resources/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteResource: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/resources/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=SessionResourceController.js.map